import React from "react";

function cn(...parts: (string | undefined | false)[]) {
  return parts.filter(Boolean).join(" ");
}

export const ButtonsWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { children?: React.ReactNode }
> = ({ className, ...props }) => (
  <div
    className={cn(
      "mx-auto mt-6 flex w-full flex-wrap items-center justify-center gap-2 sm:gap-3",
      className
    )}
    {...props}
  />
);

/** Alinhado ao NextButton do fluxo Create / Edit (#6EA5FF) */
export const NextButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, type = "button", ...props }) => (
  <button
    type={type}
    className={cn(
      "flex w-auto min-w-[100px] shrink-0 items-center justify-center rounded-md border-0 bg-[#6EA5FF] px-4 py-3 text-sm font-bold text-white transition hover:bg-[#5c94ed]",
      "[&>p]:m-0 [&>p]:text-white",
      "[&>svg]:ml-1",
      className
    )}
    {...props}
  />
);

/** Reset / Limpar — contorno visível (como o styled original) */
export const ResetButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, type = "button", ...props }) => (
  <button
    type={type}
    className={cn(
      "box-border flex w-auto min-w-[100px] shrink-0 items-center justify-center rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50",
      className
    )}
    {...props}
  />
);

/** Cadastrar / salvar fotos — RegisterButton original (#00BF33) */
export const RegisterButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, type = "button", ...props }) => (
  <button
    type={type}
    className={cn(
      "flex w-auto min-w-[100px] shrink-0 items-center justify-center rounded-md border-0 bg-[#00BF33] px-4 py-3 text-sm font-bold text-white transition hover:bg-[#00a62c]",
      "[&>p]:m-0 [&>p]:text-white",
      className
    )}
    {...props}
  />
);
